import React from 'react';
import CONSTS from 'constants/index.js';
import { GECKO_CONSTS, GeckoFields } from 'ui';
import BlockField from 'components/BlockField';
import PropTypes from 'prop-types';
import ReplyBoxField from 'components/ReplyBoxField';
import {
  buildContactGroup,
  buildSelectedChannelGroup,
} from 'services/template-tags';

const isMessageBoxEmpty = (textFromBlocks) => {
  return textFromBlocks === '';
};

const MessageEditor = (props) => {
  const { value = [], onChange = () => {} } = props;

  const templateContext = [
    buildContactGroup(),
    buildSelectedChannelGroup({
      channel: null,
      showChannelQueuePosition: true,
    }),
  ];
  // to check first paragraphs(blocks) text for last message box in a skill only
  const messageBlocks = value.map((message) => message?.blocks);
  const textFromFirstBlocks = messageBlocks.map((blocks) =>
    blocks ? blocks[0].text : ''
  );
  const getOnlyLastMessageBoxText =
    textFromFirstBlocks[textFromFirstBlocks?.length - 1];

  const fields = () => {
    return [
      {
        key: 'value',
        type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
        description:
          'These messages will be displayed to the user along with the list items you create below (max 3).',
        width: '100%',
        component: (
          <BlockField
            addButton={{ type: 'default', name: 'Add Another Message', icon: 'far fa-plus', }}
            isAddButtonDisabled={isMessageBoxEmpty(getOnlyLastMessageBoxText)}
            maxItems={3}
            field={{
              label: null,
              type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
              component: (
                <ReplyBoxField
                  compileTemplateTags={false}
                  templateContext={templateContext}
                  meta={{ mail_merge: { show: true } }}
                  formatAsEditorObject
                  editorMode={CONSTS.EDITOR_MODE_TYPE.RICH}
                />
              ),
            }}
          />
        ),
      },
    ];
  };
  const changeHandler = (_key, value) => {
    onChange(value);
  };
  return (
    <GeckoFields
      values={{ value }}
      fields={fields()}
      handler={changeHandler}
    />
  );
};
MessageEditor.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default MessageEditor;
